// IE 2026 10 24 / ODOO-348842 (заказ Игоря): карточка строки табличной части (widget-row) открывается на вкладке ⚙ «Params» команды строки.
// Чистая логика (без Vue и DOM): какая вкладка карточки — вкладка настроек команды. Вкладку присылает бэк (widget_ROW.set_view: вкладка 🏠, затем вкладки
// модели расчёта get_AttrCalcTabs — {attr_type:'AttrTab', tooltip:'Params', pi:'pi pi-cog'} — без name и title), явного признака нет.
// Хост — AttrTabPanel.rowCard_defaultTab. Выключатель fe.ux.rowCardParamsTab (дефолт вкл.)

// вкладка настроек команды: не домашняя (idx > 0), AttrTab, pi-cog, якорь 'params' (по tooltip_en — не зависит от языка); anchorKey(tab) → строка
export function rowCard_isSettingsTab(tab, idx, anchorKey) {
    if (!tab || idx <= 0 || tab.attr_type !== 'AttrTab' || tab.use === false || tab.name === 'AttrTab-row') return false
    if (!/\bpi-cog\b/.test(String(tab.pi || ''))) return false
    return typeof anchorKey === 'function' && anchorKey(tab) === 'params'
}

// индекс вкладки ⚙ в наборе вкладок главной панели карточки строки или -1 (тогда всё как прежде).
// o: { widget, metaType, mainPanel, hasCommand, activeAttr (клик из колонки-вложенного грида — вкладку выбирает он), anchorKey(tab), isVisible(tab) }
export function rowCard_paramsTabIndex(tabs, o = {}) {
    if (o.widget !== 'widget-row' || o.metaType !== 'widget-row' || !o.mainPanel || !o.hasCommand || o.activeAttr) return -1
    if (!Array.isArray(tabs)) return -1
    return tabs.findIndex((t, i) => rowCard_isSettingsTab(t, i, o.anchorKey) && (typeof o.isVisible !== 'function' || o.isVisible(t)))
}

// нужно ли применять вкладку по умолчанию в этом content_Changed: панель показана впервые (запомненной вкладки нет: первое открытие, панель создана заново при ‹ › к другой команде)
// или карточка открыта заново (метка от стора, повторное открытие после ✕ / Esc); у прежнего экземпляра (та же команда) вкладка остаётся как есть
export function rowCard_shouldApply(st = {}) {
    return !!(st.fresh || st.reset)
}
